import React from 'react';

function RenderResponsibleComponent({ rowData }) {
  if (rowData?.personsInCharge.length > 0) {
    const allPersonNameSplit = rowData.personsInCharge[0].displayName.toString().split(' ');
    const [firstName, secondName, thirdName] = [`${allPersonNameSplit[1][0] ?? ''}.`, `${allPersonNameSplit[0] ?? ''} `, `${allPersonNameSplit[2][0] ?? ''}.`];
    const post = `${rowData.personsInCharge[0]?.post?.toString().toLowerCase() ?? ''}`;
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {rowData.personsInCharge.map((person) => {
          const splittedName = person.displayName.split(' ')
          return <span key={person.id}>
            {splittedName[0]} {splittedName[1][0]}.{splittedName[2] && `${splittedName[2][0]}.`}
          </span>
        })}
      </div>
    );
  }
  return <>Не указан</>;
}

export default RenderResponsibleComponent;
